import { render, staticRenderFns } from "./IbowAccountEdit.vue?vue&type=template&id=3c4f55c1&scoped=true&"
import script from "./IbowAccountEdit.vue?vue&type=script&lang=ts&"
export * from "./IbowAccountEdit.vue?vue&type=script&lang=ts&"
import style0 from "./IbowAccountEdit.vue?vue&type=style&index=0&id=3c4f55c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4f55c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardTitle,VContainer,VForm,VSimpleTable,VSpacer})
